export function getSessionIndexFromQueryParam({
    activeSessionParam,
    sessionsLength,
    defaultIndex,
}: {
    activeSessionParam: string | null | undefined;
    sessionsLength: number;
    defaultIndex: number;
}): number {
    const activeSessionQueryParamNumber = activeSessionParam
        ? parseInt(activeSessionParam, 10)
        : NaN;

    const index = !Number.isNaN(activeSessionQueryParamNumber)
        ? activeSessionQueryParamNumber - 1
        : -1;

    return index >= 0 && index < sessionsLength ? index : defaultIndex;
}
